<template>
  <section class="d-flex flex-column h-full">
    <!-- MAIN COMMENT LIST -->
    <main
      class="bg-documentGray flex-grow-1 board_module scroll-y"
      :class="
        comments === ''
          ? 'd-flex justify-content-center align-items-center no-comment-center-checklist'
          : ''
      "
    >
      <div
        class="t-body3 font-r t-color-bodyGrayB pdt-24 pdb-24 t-center"
        v-if="comments === ''"
      >
        {{ $t("3132") }}<br />{{ $t("3133") }}
      </div>
      <div
        class="pdt-16 pdl-16 pdr-16 bg-documentGray"
        v-if="comments && comments.length > 0"
        style="padding-bottom: 100px"
      >
        <div class="d-flex" v-for="comment in comments" :key="comment.id">
          <UserImgProfile
            :allData="comment"
            :data="comment.auditor.register"
            :className="'mgr-0'"
          />

          <div
            class="flex-grow-1 pdl-16 w-200"
            @click="isOpenModal ? closeModal : ''"
          >
            <div class="d-flex">
              <div class="flex-grow-1">
                <div
                  class="t-body3 mgb-1 font-r"
                  :class="{ 't-color-bodyGrayB': comment.isBlocked }"
                >
                  {{ handleUserName(comment.auditor.register) }}
                </div>
                <div
                  class="t-body3 t-color-bodyGrayA mgr-8"
                  :class="{ 't-color-bodyGrayB': comment.isBlocked }"
                >
                  {{ $moment(comment.auditor.register.time).format("L") }}
                </div>
              </div>
              <div class="more-btn-parent-div position-relative">
                <i
                  class="material-icons t-color-iconInactive t-headline14 more_btn"
                  @click="handleModal(comment.id)"
                  @keydown.enter="handleModal(comment.id)"
                  tabindex="0"
                  >more_horiz</i
                >

                <UserDetailActionModal
                  v-if="isOpenModal && comment.id === selectedChild"
                  :type="'COMMENT'"
                  :data="comment"
                  :selectedChild="{
                    id: comment.id,
                    remove: true,
                    modify: true,
                  }"
                  @report="reportComment"
                  @block="handleBlock"
                  @edit="editCommentSet"
                  @delete="deleteComment"
                  :className="'opacity-1'"
                />
              </div>
            </div>

            <!-- COMMENT -->
            <div
              class="mgt-8 t-color-bodyGrayA t-body3"
              :class="{ 't-color-bodyGrayB': comment.isBlocked }"
              v-html="comment.isBlocked ? $t('3814') : comment.contents"
            ></div>
            <div
              class="scroll-x scroll-view hide-scrollbar"
              style="overflow-x: auto; width: 100%"
            >
              <div
                class="d-flex mgt-8 comment-attachment"
                style="min-width: fit-content"
                v-if="
                  comment &&
                  !comment.isBlocked &&
                  comment.images &&
                  comment.images.length
                "
              >
                <div
                  class="grid-3-item position-relative mgr-8 comment-attachment-item"
                  v-for="(img, i) in comment.images"
                  :key="i"
                  @click="fileDisplay(img)"
                  @keypress="fileDisplay(img)"
                  tabindex="0"
                  style="flex-shrink: 0"
                >
                  <img
                    @click="fileDisplay(img.resourceUri, false)"
                    @keypress="fileDisplay(img.resourceUri, false)"
                    v-if="getType(img.contentType) === 'image'"
                    :src="img.resourceUri"
                    :alt="img.originalName"
                    tabindex="0"
                    style="width: 100px; height: 100px; object-fit: cover"
                  />
                  <video-player
                    class="video-player-box comment-video"
                    v-if="getType(img.contentType) === 'video'"
                    ref="videoPlayer"
                    :options="getPlayerOption(img)"
                    :playsinline="true"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="t-helper t-color-iconInactive pdt-8 pdb-16 font-r"  @click="toggleReply(comment.id,comment.auditor.register.name.fullName)" v-if="selectedChild && selectedChild.register === true" >{{$t('3378')}} </div> -->

            <div
              class="t-helper t-color-iconInactive pdt-8 pdb-16 font-r"
              @click="
                toggleReply(comment.id, comment.auditor.register.name.fullName)
              "
              @keypress="
                toggleReply(comment.id, comment.auditor.register.name.fullName)
              "
              tabindex="0"
            >
              <span v-if="!comment.isBlocked">{{ $t("3378") }}</span>
            </div>
            <input type="hidden" id="replyCommentId" />
            <div
              class="d-grid flex-column d-none"
              :id="`commentInput_${comment.id}`"
            ></div>
            <div
              class="pdb-16"
              v-for="reply in comment.children"
              :key="reply.id"
            >
              <div class="d-flex">
                <UserImgProfile
                  :allData="reply"
                  :data="reply.auditor.register"
                  :size="'xs'"
                  :className="'mgr-0'"
                />

                <div class="flex-grow-1 pdl-16 w-200">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div
                        class="t-body3 mgb-1 font-r"
                        :class="{ 't-color-bodyGrayB': reply.isBlocked }"
                      >
                        {{ handleUserName(reply.auditor.register) }}
                      </div>
                      <div
                        class="t-body3 t-color-bodyGrayA mgr-8"
                        :class="{ 't-color-bodyGrayB': reply.isBlocked }"
                      >
                        {{ $moment(reply.auditor.register.time).format("L") }}
                      </div>
                    </div>
                    <div class="more-btn-parent-div position-relative">
                      <i
                        class="material-icons t-color-iconInactive t-headline14 more_btn"
                        @click="handleModal(reply.id)"
                        @keydown.enter="handleModal(reply.id)"
                        tabindex="1"
                      >
                        more_horiz
                      </i>
                      <!-- 대댓글 액션 모달 -->
                      <UserDetailActionModal
                        v-if="isOpenModal && reply.id === selectedChild"
                        :type="'REPLY'"
                        :data="reply"
                        :parentData="comment"
                        :selectedChild="{
                          id: reply.id,
                          remove: true,
                          modify: true,
                        }"
                        @report="reportComment"
                        @block="handleBlock"
                        @edit="editReplySet"
                        @delete="deleteComment"
                        :className="'opacity-1'"
                      />
                    </div>
                  </div>

                  <!-- REPLY -->
                  <div
                    class="mgt-8 t-color-bodyGrayA t-body3"
                    :class="{ 't-color-bodyGrayB': reply.isBlocked }"
                    v-html="reply.isBlocked ? $t('3814') : reply.contents"
                  ></div>
                  <div class="scroll-x scroll-view-reply">
                    <div
                      class="d-flex mgt-8 comment-attachment reply-comment-img fixed-width"
                      style="min-width: fit-content"
                      v-if="
                        reply &&
                        !reply.isBlocked &&
                        reply.images &&
                        reply.images.length
                      "
                    >
                      <div
                        class="grid-3-item position-relative mgr-8 comment-attachment-reply-item"
                        v-for="(img, l) in reply.images"
                        :key="l"
                        @click="fileDisplay(img)"
                        @keypress="fileDisplay(img)"
                        tabindex="0"
                      >
                        <img
                          v-if="getType(img.contentType) === 'image'"
                          :src="img.resourceUri"
                          :alt="img.originalName"
                          style="
                            background-color: transparent;
                            width: 100px;
                            height: 100px;
                            object-fit: cover;
                          "
                        />
                        <video-player
                          class="video-player-box comment-video"
                          v-if="getType(img.contentType) === 'video'"
                          :options="getPlayerOption(img)"
                          :playsinline="true"
                        />
                        <div
                          style="
                            position: absolute;
                            background-color: transparent;
                            width: 100px;
                            height: 100px;
                            top: 0;
                            z-index: 999;
                          "
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="divider" v-if="currentPage < totalPages"></div>
      <div class="bg-documentGray">
        <button
          type="button"
          v-if="currentPage < totalPages"
          class="btn btn-secondary w-full pdt-10 pdb-10"
          @click="getComments"
          @keypress="getComments"
          tabindex="0"
        >
          {{ $t("3093") }}
        </button>
      </div>
    </main>

    <!-- FOOTER TEXTAREA -->
    <div class="textBlock w-full bg-white fixed-bottom-footer">
      <div class="divider"></div>
      <div
        class="d-flex flex-grow-1 pdt-16 pdb-15 pdl-16 pdr-16 position-relative"
      >
        <div
          ref="mentionTextArea"
          class="t-body3 t-color-linkBlue font-r bg-linkBg mention-text-area mgr-8 d-flex align-items-center mgt--4 position-absolute z-99 pda-0"
          v-if="userName"
        >
          @{{ userName
          }}<span
            class="cursor-pointer t-color-iconInactive pdl-8 pdr-4 mgr-8"
            @click="toggleReply"
            @keypress="toggleReply"
            tabindex="0"
            >x</span
          >
        </div>
        <textarea
          @focus="resizeIt($event.target.value)"
          @keyup="resizeIt($event.target.value)"
          @click="setActive"
          @keypress="setActive"
          tabindex="0"
          @input="handleInput"
          class="cursor-blue comment_textarea mdc-text-field__input t-body3 border-none t-color-headlineBlack t-line-height t-justify pda-0"
          :class="{ commentInvaliderror: commentValid }"
          v-model="form.contents"
          :placeholder="$t('3378')"
          ref="answerTextarea"
          id="comment_textarea"
          rows="3"
        ></textarea>
      </div>
      <div
        class="attachedFileContainer scroll-x attached-file-container"
        v-if="form.images.length > 0"
      >
        <div
          class="post-video position-relative attach-video comment-attachment-box pdr-22"
          v-for="(img, i) in form.images"
          :key="i"
        >
          <img
            :src="img.resourceUri"
            :alt="img.originalName"
            v-if="getType(img.contentType) === 'image'"
          />
          <video-player
            v-if="getType(img.contentType) === 'video'"
            class="video-player-box attach-video"
            :options="{
              muted: true,
              language: 'en',
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: [{ type: img.contentType, src: img.resourceUri }],
              height: 100,
              width: 100,
            }"
            :playsinline="true"
          />
          <span
            @click="removeItem(i)"
            @keypress="form.images.splice(i, 1)"
            class="remove-img remove-image-new position-absolute t-color-white"
            tabindex="0"
            ><img
              src="/images/close.svg"
              class="w-16 h-16"
              alt="파일프리뷰 닫기버튼"
          /></span>
        </div>
      </div>
      <div class="pdb-34">
        <div class="d-flex justify-content-between pda-4">
          <div class="d-flex">
            <input
              id="commentFileUpload"
              ref="input"
              :accept="allowExt()"
              class="d-none"
              name="image"
              type="file"
              @change="uploadFile"
            />

            <button
              :class="{
                't-color-iconActive': isGalleryInput,
                't-color-textfieldGuid': !isGalleryInput,
                'has-item-col': form.images.length > 0,
              }"
              class="material-icons mdc-icon-button"
              tabindex="0"
              @click="openFileUpload('commentFileUpload')"
              @keypress="openFileUpload('commentFileUpload')"
            >
              collections
            </button>

            <input
              id="cameraFileUpload"
              :accept="allowImgExt()"
              capture="camera"
              class="d-none"
              name="camera"
              type="file"
              @change="uploadFile"
            />
            <button
              :class="
                isCameraInput ? 't-color-iconActive' : 't-color-textfieldGuid'
              "
              class="material-icons mdc-icon-button"
              tabindex="0"
              @click="openFileUpload('cameraFileUpload')"
              @keyup.enter="openFileUpload('cameraFileUpload')"
            >
              photo_camera
            </button>
            <slot name="attachFile"></slot>
          </div>
          <button
            class="mdc-icon-button sendMessageBtn t-color-white align-items-center justify-content-between"
            :class="{ on: coomentActiveButton }"
            @click="submitComment"
            @keyup.enter="submitComment"
            tabindex="0"
          >
            <i
              :class="{
                'has-item': form.contents || this.form.images.length > 0,
              }"
              class="material-icons min-w-24 min-h-24 font-size-20"
              >arrow_upward</i
            >
          </button>
        </div>
      </div>
      <div
        v-if="isOpenModal"
        @click="closeModal"
        @keyup.enter="closeModal"
        class="modal-background"
      />
    </div>
    <!-- <div class="mdc-dialog__scrim backlayer" :class="backFixLayer ? 'show' : ''"></div> -->
  </section>
</template>

<script>
import { MDCMenu } from "@material/menu";
import checklistApi from "@/api/checklistApi.js";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import { userMixin } from "@/mixins/user";
import { fileMixin } from "@/mixins/file";
import UserImgProfile from "@/components/common/checkUser/UserImgProfile.vue";
import UserDetailActionModal from "@/components/common/modal/UserDetailActionModal.vue";
import { mediaTypeConstants } from "@/utils/enum/MediaTypeConstants";
import _ from "lodash";
export default {
  mixins: [userMixin, fileMixin],
  data() {
    return {
      menuBar: null,
      headerName: null,
      userAuthData: null,
      detail: null,
      isComment: true,
      comments: [],
      coomentActiveButton: false,
      commentValid: false,
      commentEdit: false,
      commentEditId: null,
      selectedChild: null,
      setColor: false,
      mamberData: [],
      fullName: "",
      previewImageUrl: null,
      form: {
        contents: "",
        images: [],
      },
      replyImg: [],
      currentPage: 1,
      totalPages: 1,
      b: true,
      userName: "",
      evtReply: {},
      commentBottom: true,
      firstCharOfNames: localStorage.getItem("firstChar"),
      bgColorOfName: localStorage.getItem("bgColors"),
      backFixLayer: false,
      useColorId: [],
      backColorOfId: [],
      showToggle: false,
      isOpenModal: false,
      responseData: null,
    };
  },

  components: {
    videoPlayer,
    UserImgProfile,
    UserDetailActionModal,
  },
  computed: {
    isCameraInput() {
      return _.some(this.form.images || this.form.contents.files, (img) => {
        return img.fileType === mediaTypeConstants.MEDIA_FILE_TYPE.CAMERA;
      });
    },

    isGalleryInput() {
      return _.some(this.form.images || this.form.contents.files, (img) => {
        return img.fileType === mediaTypeConstants.MEDIA_FILE_TYPE.IMAGE;
      });
    },
  },
  queryBoardName() {
    return this.$route.query.boardName;
  },
  watch: {
    userName: {
      handler(state) {
        if (state.length >= 1) {
          this.$refs.answerTextarea.focus();
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.fetchMembers();

    this.getComments();
    this.$nextTick(() => {
      const menuEls = Array.from(document.querySelectorAll(".mdc-menu"));
      menuEls.forEach((menuEl) => {
        this.menuBar = new MDCMenu(menuEl);
        const dropdownToggle = menuEl.parentElement.querySelector(
          ".js--dropdown-toggle"
        );
        dropdownToggle.addEventListener("click", () => {
          this.menuBar.open = !this.menuBar.open;
        });
      });
    });
  },

  methods: {
    async fetchMembers() {
      try {
        const response = await checklistApi.fetchMember();
        this.mamberData = response.data.data;
        this.firstName = response.data.data.name.first;
        this.lastName = response.data.data.name.last;
        this.fullName = response.data.data.name.fullName.trim();
      } catch (err) {
        this.responseData = err.response.data.meta;
        this.$error({ content: this.responseData.err }).then(() => {});
      }
    },
    toggleDocument() {
      this.$emit("toggleDocument");
    },

    /**
     * 아이디 선택자 클릭 메소드
     * @param {String} status 선택자 아이디 엘레먼트
     */

    closePreview() {
      // console.log('close preview')
      this.showImagePreview = false;
      this.previewImageUrl = null;
      // 			setTimeout(()=>{
      // this.myTriggerFunc();
      // },0)
    },
    //Alert box report
    askForReport(status) {
      if (status) return;
      this.$confirm({
        content: this.$t("1450"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
        accept: this.$t("1451"), // 확인
        cancel: this.$t("1447"), //'TODO-취소'
      })
        .then(() => {
          this.reportPost();
        })
        .catch(() => {});
    },

    //Alert box delete
    askForDelete() {
      this.$confirm({
        content: this.$t("1877"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
        accept: this.$t("1879"), // 확인
        cancel: this.$t("1878"), //'TODO-취소'
      })
        .then(() => {
          this.deletePost();
        })
        .catch(() => {});
    },

    //Generate Report by loggedIn user
    reportPost() {
      this.$showLoading();
      checklistApi
        .reportComment(this.$route.params)
        .then((response) => {
          this.$hideLoading();
          if (response) {
            this.detail.report = true;
          }
        })
        .catch((err) => {
          this.$hideLoading();
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },

    //Delete post by loggedIn user
    async deletePost() {
      this.$showLoading();
      try {
        const response = await checklistApi.deletePost(this.$route.params);
        if (response) {
          this.$hideLoading();
          this.goToPrevious();
        }
      } catch (error) {
        console.error("error", error);
      }
    },

    // Comment list
    getComments(resetPage = false) {
      if (resetPage) {
        this.currentPage = 1;
        this.comments = [];
      }

      let params = this.setParams();
      this.$showLoading();
      checklistApi
        .listComments(this.$route.params, params)
        .then((response) => {
          this.$hideLoading();
          let responseData = response.data.data;

          if (resetPage) {
            this.comments = responseData.content;
          } else {
            this.comments = this.comments.concat(responseData.content);
          }

          this.currentPage++;
          this.totalPages = responseData.totalPages;
        })
        .catch((err) => {
          this.$hideLoading();
          // 에러 처리 추가
        });
    },

    setParams(num) {
      if (num) this.currentPage = num;
      let params = {
        page: this.currentPage,
        size: 50,
      };
      return params;
    },

    // 댓글 목록 새로고침 (페이지 초기화)
    refreshComments() {
      this.getComments(true);
    },

    // Preview of image and video
    fileDisplay(data) {
      this.$emit("previewImage", data.resourceUri);
    },

    uploadFile(evt) {
      try {
        if (!evt.target.files[0]) return;
        if (!this.invalidCountImg()) return;
        if (
          !this.mediaTypeValidCheck(evt.target.files[0], "MEDIA") ||
          (this.isComment && !this.invalidCountImg())
        ) {
          this.$hideLoading();
          return;
        }

        this.$showLoading();
        checklistApi
          .upload(evt.target.files[0])
          .then((response) => {
            // check if Image need to add into reply or comment
            if (this.isComment) this.form.images.push(response.data.data[0]);
            else this.replyImg.push(response.data.data[0]);

            this.$hideLoading();
          })
          .catch((err) => {
            this.$hideLoading();
            this.$error({ content: err.errMsg }).then(() => {});
          });
      } catch (err) {
        console.log(err);
      }
    },
    // check if image selected then count number of image selected
    invalidCountImg() {
      if (this.isComment && this.form.images.length >= 5) {
        this.$alert({
          content: this.$t("1469"),
          accept: this.$t("1470"),
        });
        return false;
      } else {
        if (this.replyImg.length >= 5) {
          this.$alert({
            content: this.$t("1469"),
            accept: this.$t("1470"),
          });
          return false;
        }
      }
      return true;
    },

    resizeIt() {
      const textarea = this.$refs.answerTextarea;
      const lineHeight = parseInt(getComputedStyle(textarea).lineHeight, 10);
      const maxHeight = lineHeight * 3;

      if (textarea.scrollHeight > maxHeight) {
        textarea.style.height = "auto";
        textarea.style.overflowY = "scroll";
      } else if (textarea.scrollHeight > lineHeight * 1.5) {
        textarea.style.height = "auto";
        textarea.style.overflowY = "hidden";
      }
      let replyedBy = document.querySelector(".mention-text-area").clientWidth;
      if (replyedBy) {
        document.querySelector("#comment_textarea").style.textIndent =
          replyedBy + 8 + "px";
      } else {
        document.querySelector("#comment_textarea").style.textIndent = "0px";
      }
    },

    setActive() {
      this.coomentActiveButton = true;
    },

    // Submit Comment
    submitComment() {
      if (this.b === true) {
        if (
          (this.form.contents && this.form.contents.length > 0) ||
          (this.form && this.form.images.length > 0)
        ) {
          this.commentValid = false;
          this.$showLoading();
          if (this.commentEdit) {
            checklistApi
              .commentEdit(this.$route.params, this.form, this.commentEditId)
              .then((resp) => {
                // reset comment form
                this.resetCommentForm();
                let commentIndex = this.comments.findIndex(
                  (el) => el.id == resp.data.data.id
                );
                this.comments[commentIndex] = resp.data.data;
                this.commentEdit = false;
                this.$hideLoading();
              })
              .catch((err) => {
                this.$error({ content: err.errMsg }).then(() => {});
              });
          } else {
            checklistApi
              .commentPost(this.$route.params, this.form)
              .then((resp) => {
                // reset comment form
                this.resetCommentForm();
                // 새 댓글을 목록 맨 뒤에 추가
                this.comments.push(resp.data.data);
                this.$hideLoading();
              })
              .catch((err) => {
                this.$error({ content: err.errMsg }).then(() => {});
              });
          }
        } else {
          this.commentValid = true;
        }
      } else {
        let commentId = document.getElementById("replyCommentId").value;
        this.submitReply(commentId);
      }
      this.$refs.input.value = "";
    },

    // Empty Comment Textarea after submit
    resetCommentForm() {
      this.form = {
        contents: null,
        images: [],
      };
    },

    // open modal
    handleModal(id) {
      this.selectedChild = id;
      this.isOpenModal = !this.isOpenModal;
    },

    closeModal() {
      this.selectedChild = null;
      this.isOpenModal = false;
    },

    async handleBlock(item, isBlocked) {
      await this.blockUser(item, isBlocked);
      this.closeModal();
      window.location.reload();
    },

    async reportComment(data) {
      if (data.report) {
        this.closeModal();
        return this.$snackOpen({
          contents: this.$t("S20085"),
        }).then(() => {});
      }

      try {
        this.$showLoading();

        await checklistApi.reportComment(
          { postId: this.$route.params.postId },
          data.id
        );

        data.report = true;
      } catch (error) {
        console.log("Report Comment Error", error);
        this.$error({ content: error.errMsg }).then(() => {});
      } finally {
        this.$hideLoading();
        this.closeModal();
      }
    },

    // TODO : 기존 삭제 기능 작동 X
    async deleteComment(item) {
      this.$showLoading();
      this.closeModal();
      try {
        await checklistApi.deleteComment(this.$route.params, item);
        // 댓글 삭제 후 목록 새로고침
        this.refreshComments();
      } catch (err) {
        this.$error({ content: err.errMsg }).then(() => {});
      } finally {
        this.$hideLoading();
      }
    },

    editCommentSet(comment) {
      this.commentBottom = true;
      this.userName = "";
      this.replyEditId = "";
      this.replyEdit = false;
      this.form.contents = comment.contents;
      this.form.images = comment.images;
      this.commentEditId = comment.id;
      this.commentEdit = true;
      this.closeModal();
    },

    // Edit Reply Textarea
    editReplySet(reply, cid, evt, userId) {
      this.commentEditId = "";
      this.commentEdit = false;
      this.commentBottom = false;
      this.form.contents = reply.contents;
      this.form.images = reply.images;
      this.replyEditId = reply.id;
      this.replyEdit = true;

      // this.replyImg       =   reply.images;
      // this.replyEditId    =   reply.id;
      // this.replyEdit      =   true;
      // $('#reply_text'+cid).val(reply.contents);
      this.closeModal();
      this.toggleReply(cid, userId);
    },

    // Reply button
    toggleReply(commentId, userId) {
      this.setColor = true;
      this.commentBottom = false;
      this.userName = userId;
      this.b = !this.b;
      //this.b == false ? document.getElementById('replyCommentId').value = commentId : document.getElementById('replyCommentId').value='';
      let comeId = (document.getElementById("replyCommentId").value =
        commentId);
      if (comeId && this.b === false) {
        this.$nextTick(() => {
          this.resizeIt();
        });
      } else {
        this.userName = "";
        document.querySelector("#comment_textarea").style.textIndent = "0px";
      }
      //this.b == false ? this.userName : this.userName=''
      document
        .getElementById(`commentInput_${commentId}`)
        .classList.toggle("d-none");
    },

    // Submit Reply comment
    submitReply(originId) {
      this.$showLoading();
      if (!this.replyEdit) {
        // 대댓글 신규 등록
        checklistApi
          .postReply(this.$route.params, originId, this.form)
          .then((response) => {
            this.$hideLoading();
            this.submitSuccess(originId);

            const parentComment = this.comments.find(
              (c) => Number(c.id) === Number(originId)
            );
            if (parentComment) {
              parentComment.children.push(response.data.data);
            }
          })
          .catch((err) => {
            this.$error({ content: err.errMsg }).then(() => {});
          });
      } else {
        checklistApi
          .editReply(this.$route.params, this.replyEditId, this.form)
          .then((response) => {
            this.$hideLoading();
            this.submitOther(originId);
            // add reply into parent

            const parentComment = this.comments.find(
              (c) => c.id === this.replyEditId
            );
            if (parentComment) {
              this.comments.children.push(response.data.data);
              this.replyEditId = null;
            }
          })
          .catch((err) => {
            this.$error({ content: err.errMsg }).then(() => {});
          });
      }
    },

    submitSuccess(originId) {
      this.resetCommentForm();
      this.toggleReply(originId);
      this.replyImg = [];
      // 댓글 작성 후 전체 목록을 다시 로딩하지 않음
      this.userName = "";
    },

    submitOther(originId) {
      this.resetCommentForm();
      this.toggleReply(originId);
      this.replyImg = [];
      this.replyEdit = false;
      // 댓글 수정 후 전체 목록을 다시 로딩하지 않음
      this.userName = "";
    },

    goToPrevious() {
      const routeCategory = this.$route.query.categoryName || null;
      if (this.$route.query && this.$route.query.fromPage === "main") {
        this.$router.push("/home");
      } else {
        this.$router.push(
          "/board/" +
            this.$route.params.boardId +
            "?boardName=" +
            encodeURI(this.queryBoardName) +
            "&categoryName=" +
            encodeURI(routeCategory)
        );
      }
    },

    handleInput(event) {
      this.form.contents = event.target.value;
    },
    removeItem(i) {
      this.form.images.splice(i, 1);
      this.$refs.input.value = "";
    },
  },
};
</script>
<style scoped>
section {
  padding-top: 64px;
  /* padding-bottom: 147px; */
}

main {
  padding-bottom: 147px;
}

.backlayer.show {
  opacity: 1;
  background: transparent;
  z-index: 7;
  display: block;
}
.more-btn-parent-div {
  z-index: revert;
}

.modal-background {
  background: rgba(0, 0, 0, 0.01);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.more_box {
  padding: 0 !important;
}
.t-line-height {
  line-height: 1.5 !important;
}
.z-index-1 {
  z-index: 1;
}
.has-item {
  background-color: var(--Textfeildguid);
  border-radius: 50%;
  font-size: 18px !important;
}
.has-item-col {
  color: #242f3b !important;
}
.font-size-20 {
  font-size: 20px !important;
}
.comment-attachment-box {
  width: 48px;
  height: 48px;
}
.comment-attachment-item {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.comment-attachment-reply-item {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.attached-file-container {
  gap: 22px;
}
.hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE, Edge */
}
.hide-scrollbar::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
</style>